'use strict';

var React = require('react');
require('prop-types');
var ObjectHelper = require('../../common/ObjectHelper.js');
var useTheme = require('../../DesignSystem/Styles/useTheme.js');
var Avatar = require('../../node_modules/@material-ui/core/esm/Avatar/Avatar.js');
var Chip = require('../../node_modules/@material-ui/core/esm/Chip/Chip.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function EmployeeChip(_ref) {
  var avatarUrl = _ref.avatarUrl,
      color = _ref.color,
      nameInitials = _ref.nameInitials,
      name = _ref.name,
      onDelete = _ref.onDelete,
      chipColorStyle = _ref.chipColorStyle;
  var theme = useTheme();

  var sanitizeColor = function sanitizeColor() {
    return color.includes('#') ? color : "#".concat(color);
  };

  var avatarColor = color ? sanitizeColor() : theme.palette.alert.main;
  var avatar = ObjectHelper.isBlank(avatarUrl) ? React__default["default"].createElement(Avatar["default"], {
    style: {
      backgroundColor: avatarColor
    }
  }, nameInitials) : React__default["default"].createElement(Avatar["default"], {
    src: avatarUrl
  });
  return React__default["default"].createElement(Chip["default"], {
    avatar: avatar,
    label: name,
    onDelete: onDelete,
    color: chipColorStyle
  });
}

EmployeeChip.defaultProps = {
  avatarUrl: '',
  color: undefined,
  nameInitials: '',
  name: '',
  onDelete: undefined,
  chipColorStyle: 'default'
};

module.exports = EmployeeChip;
